import { gql } from 'apollo-angular';

export const AddToFunnelDocument = gql(/* GraphQL*/ `mutation addToFunnel($id: Int!) {
  addToFunnel(tacticId: $id)
}
`);
